
import { PreviewOptions } from '@/editor/types'

export enum EDITOR_MODE {
  NEW,
  REVISE_DESIGN_CART_ITEM,
  REVISE_DESIGN_ORDER_ITEM
}

export const EDITOR_GRID_CONFIGS = {
  RULER_WIDTH: 32,
  CANVAS_STROKE_COLOR: 'rgb(255,255,255)',
  CANVAS_STROKE_LINE: 1,
  FONT_FAMILY: 'Hiragino Sans, Hiragino Kaku Gothic ProN, Meiryo, Arial, sans-serif',
  FONT_SIZE: 12
}

export const ZOOM_CONFIG = {
  ADDITIONAL_RATIO : 0.3,
  MAX_RATIO : 1.3,
  MIN_RATIO : 0.4
}

export const PRIORITY = {
  SPEED: 'speed',
  QUALITY: 'quality'
}

export const PREVIEW_OPTIONS: PreviewOptions[] = [
  {
    title: '納期優先',
    note: '一般的な範囲でスピードを優先してデータの確認をおこないます ',
    recommend: 'こんな方にオススメ',
    recommendList: ['シンプルで簡単なデザイン', '簡単な配布物を作りたい'],
    value: PRIORITY.SPEED
  },
  {
    title: '品質優先',
    note: '隅々までデータを確認するため、複雑なデザインの場合お時間頂く可能性があります。',
    recommend: 'こんな方にオススメ',
    recommendList: ['線が細かったり複雑なデザイン', '記念品としてしっかり作りたい'],
    value: PRIORITY.QUALITY
  }
]

export default {
  CURRENT_PRINT_COLOR_KEY: 'current_print_color',
  ACTIVE_OBJECT_TYPES: {
    text: 'text',
    itext: 'i-text',
    image: 'image',
    activeSelection: 'activeSelection',
    verticalText: 'vertical-text'
  },
  TIMEOUT_ERROR: 'TimeOut',
  PLUS: 'plus',
  ACTIONS: {
    UNDO: 'undo',
    REDO: 'redo'
  },
  ENDPOINT: {
    PRINTABLE_SKUS: '/api/v1/printable_skus/',
    SUBMISSIONS: '/api/v1/submissions/',
    SUBMISSION: '/api/v1/submissions/%uuid',
    MULTIPLE_SUBMISSIONS: '/api/v1/multiple_submissions/',
    CART_ITEMS_SUBMISSIONS: '/api/v1/cart_items/%s/submissions',
    CART_ITEMS_SELECTED_COLOR: '/api/v1/cart_items/%s/selected_colors',
    CART_ITEMS: '/cart_items/',
    CART: '/cart',
    UPLOAD_USER_IMAGE: '/api/v1/user_upload_images/',
    ORDER_ITEM_SUBMISSION: 'api/v1/order_items/%s/submissions',
    ORDER_ITEM_SELECTED_COLOR: 'api/v1/order_items/%s/selected_colors',
    SUBMISSION_REVISIONS: '/api/v1/submission_revisions/%uuid',
    MULTIPLE_SUBMISSION_REVISIONS: '/api/v1/multiple_submission_revisions',
    SUBMISSION_APPLY_REVISION: '/apply_multiple_revisions'
  },
  COLOR_PATTERNS: {
    fullColor: 'fullColor',
    cmykSingleColor: 'cmykSingleColor',
    specialSingleColor: 'specialSingleColor'
  },
  KEY_CODES: {
    LEFT: 37,
    RIGHT: 39,
    TOP: 38,
    BOTTOM: 40,
    DELETE: 8,
    C: 67,
    V: 86,
    Y: 89,
    Z: 90
  },
  TAG_NAME: {
    TEXTAREA: 'TEXTAREA'
  },
  FONT_FAMILIES: [
    {
      cssName: 'Gothic MB101 Medium JIS2004',
      name: 'ゴシックMB101 M',
      fileName: 'gothic-mb101-medium-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Gothic MB101 Bold JIS2004',
      name: 'ゴシックMB101 B',
      fileName: 'gothic-mb101-bold-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Go Medium JIS2004',
      name: '新ゴ M',
      fileName: 'shin-go-medium-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Go Bold JIS2004',
      name: '新ゴ B',
      fileName: 'shin-go-bold-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Maru Go Medium JIS2004',
      name: '新丸ゴ M',
      fileName: 'shin-maru-go-medium-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Shin Maru Go Bold JIS2004',
      name: '新丸ゴ B',
      fileName: 'shin-maru-go-bold-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Jun 501',
      name: 'じゅん 501',
      fileName: 'jun-501',
      category: 'standard'
    },
    {
      cssName: 'A1 Mincho',
      name: 'A1明朝',
      fileName: 'a1-mincho',
      category: 'standard'
    },
    {
      cssName: 'Ryumin Bold KL JIS2004',
      name: 'リュウミン B-KL',
      fileName: 'ryumin-bold-kl-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Ryumin Heavy KL JIS2004',
      name: 'リュウミン H-KL',
      fileName: 'ryumin-heavy-kl-jis2004',
      category: 'standard'
    },
    {
      cssName: 'Midashi Min MA31 JIS2004',
      name: '見出しミン MA31',
      fileName: 'midashi-min-ma31',
      category: 'standard'
    },
    {
      cssName: 'Folk Bold',
      name: 'フォーク B',
      fileName: 'folk-bold',
      category: 'fashionable'
    },
    {
      cssName: 'Maru Folk Bold',
      name: '丸フォークB',
      fileName: 'maru-folk-bold',
      category: 'fashionable'
    },
    {
      cssName: 'Kakumin Regular',
      name: 'カクミン R',
      fileName: 'kakumin-regular',
      category: 'fashionable'
    },
    {
      cssName: 'Kakumin Bold',
      name: 'カクミン B',
      fileName: 'kakumin-bold',
      category: 'fashionable'
    },
    {
      cssName: 'Kumoyaji',
      name: 'くもやじ',
      fileName: 'kumoyaji',
      category: 'cute'
    },
    {
      cssName: 'Haruhi Gakuen',
      name: 'はるひ学園',
      fileName: 'haruhi-gakuen',
      category: 'cute'
    },
    {
      cssName: 'Moaria Regular',
      name: 'モアリア R',
      fileName: 'moaria-regular',
      category: 'cute'
    },
    {
      cssName: 'Moaria Bold',
      name: 'モアリア B',
      fileName: 'moaria-bold',
      category: 'cute'
    },
    {
      cssName: 'Kaimin Tsuki Bold',
      name: '解ミン月 B',
      fileName: 'kaimin-tsuki-bold',
      category: 'cute'
    },
    {
      cssName: 'Cinema Letter',
      name: 'シネマレター',
      fileName: 'cinema-letter',
      category: 'cute'
    },
    {
      cssName: 'Shin Go Futoline',
      name: '新ゴ 太ライン',
      fileName: 'shin-go-futoline',
      category: 'decorative'
    },
    {
      cssName: 'Shin Go Shadow',
      name: '新ゴ シャドウ',
      fileName: 'shin-go-shadow',
      category: 'decorative'
    },
    {
      cssName: 'Shin Go Emboss',
      name: '新ゴ エンボス',
      fileName: 'shin-go-emboss',
      category: 'decorative'
    },
    {
      cssName:'Shin Maru Go Futoline',
      name: '新丸ゴ 太ライン',
      fileName: 'shin-maru-go-futoline',
      category: 'decorative'
    },
    {
      cssName: 'Shin Maru Go Shadow',
      name: '新丸ゴ シャドウ',
      fileName: 'shin-maru-go-shadow',
      category: 'decorative'
    },
    {
      cssName: 'Shin Maru Go Emboss',
      name: '新丸ゴ エンボス',
      fileName: 'shin-maru-go-emboss',
      category: 'decorative'
    },
    {
      cssName: 'Kakushin Gyousho Medium',
      name: '角新行書 M',
      fileName: 'kakushin-gyousho-medium',
      category: 'brush'
    },
    {
      cssName: 'Kanteiryu',
      name: '勘亭流',
      fileName: 'kanteiryu',
      category: 'brush'
    },
    {
      cssName: 'Sei Kaisho CB1',
      name: '正楷書CB1',
      fileName: 'sei-kaisho-cb1',
      category: 'brush'
    },
    {
      cssName: 'Kaisho MCBK1',
      name: '楷書MCBK1',
      fileName: 'kaisho-mcbk1',
      category: 'brush'
    },
    {
      cssName: 'UD Shin Go Medium JIS2004',
      name: 'UD新ゴ M',
      fileName: 'ud-shin-go-medium',
      category: 'ud'
    },
    {
      cssName: 'UD Shin Go Bold JIS2004',
      name: 'UD新ゴ B',
      fileName: 'ud-shin-go-bold',
      category: 'ud'
    },
    {
      cssName: 'UD Shin Maru Go Medium JIS2004',
      name: 'UD新丸ゴ M',
      fileName: 'ud-shin-maru-go-medium',
      category: 'ud'
    },
    {
      cssName: 'UD Shin Maru Go Bold JIS2004',
      name: 'UD新丸ゴ B',
      fileName: 'ud-shin-maru-go-bold',
      category: 'ud'
    },
    {
      cssName: 'UD Reimin Medium JIS2004',
      name: 'UD黎ミン M',
      fileName: 'ud-reimin-medium',
      category: 'ud'
    },
    {
      cssName: 'UD Reimin Bold JIS2004',
      name: 'UD黎ミン B',
      fileName: 'ud-reimin-bold',
      category: 'ud'
    }
  ],
  FONT_CATEGORIES: {
    standard: 'スタンダード',
    fashionable: 'おしゃれ',
    cute: 'かわいい',
    decorative: '飾り文字',
    brush: '筆文字',
    ud: 'プロ向けUD書体'
  },
  TOOL_PANEL_TITLES: {
    text: '文字',
    image: '画像',
    activeSelection: 'グループ'
  },
  TEXT_FORM_OPTIONS: {
    fontSize: [12, 13, 14, 18, 24, 30, 36, 42, 48, 60, 72, 96, 120],
    lineHeight: [1, 1.1, 1.2, 1.3, 1.4, 1.5, 1.6, 1.7, 1.8, 1.9, 2],
    charSpacing: [
      {
        name: '狭く',
        value: -171
      },
      {
        name: 'やや狭く',
        value: -91
      },
      {
        name: '標準',
        value: 0
      },
      {
        name: 'やや広く',
        value: 171
      },
      {
        name: '広く',
        value: 343
      }
    ]
  },
  MESSAGE: {
    imageSizeLimit:
      'アップロードできる画像の容量は50MBまでです。50MB以下の画像をご利用ください。',
    imageDimensionLimit:
      'アップロードした画像のサイズが8000pxを超えています。縦横のサイズが8000px以下の画像をご利用ください。',
    imageMimeType:
      'アップロードした画像はpng形式以外の画像です。png形式の画像をご利用ください。'
  },
  EDITOR_MODE: {
    NEW: 'new',
    REVISE_DESIGN_CART_ITEM: 'reviseDesignCartItem',
    REVISE_DESIGN_ORDER_ITEM: 'reviseDesignOrderItem'
  }
}
